module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.0bd2fd2d.woff2";